/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgClockArrowIn = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 12a8 8 0 1 0-8 8v2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10c0 1.167-.2 2.29-.57 3.333l-1.885-.666c.294-.833.455-1.73.455-2.667zm-7-6v5.382l3.447 1.724-.894 1.788L11 12.618V6z" />
        <path d="M23 19h-4.586l1.293-1.293-1.414-1.414L14.586 20l3.707 3.707 1.414-1.414L18.414 21H23z" />
      </g>
    </g>
  </Icon>
);
export { SvgClockArrowIn as ClockArrowIn };
